var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarDialupSet",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Dialup set"
                                                : "Ver Detalle Dialup Howen"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: { sm8: "", md8: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.enable.label,
                                          items: _vm.formFields.enable.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEnable,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.enable.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.enable,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.enable.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.type.label,
                                          items: _vm.formFields.type.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedType,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.type.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.type,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.type.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.apn.label,
                                          items: _vm.formFields.apn.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedApn,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.apn.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.apn,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.apn.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverCode.label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverCode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverCode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverCode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.user.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.user.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.user,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.user.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm8: "", md8: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.password.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.password.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.password,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.password.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }